/* eslint-disable react/no-array-index-key */
import { Stack, Typography } from '@mui/material';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import signUpService from '@services/preorder/auth';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactChannelIO } from 'react-channel-plugin';
import { BOTTOM_NAVS } from '@constants/utils';
import MyModal from 'pages-preorder/components/Modal';

import { setActiveNav } from '@store/reducers/pre-order/app';
import userService from '@services/preorder/user';
import CustomerServiceLinks from './components/CustomerServiceLinks';

const MyPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { version } = useParams();
  const { t } = useTranslation();
  const [policyList, setPolicyList] = useState([]);
  const location = useLocation();
  const { activeNav } = useSelector((state) => state.preOrder.app);
  const [selectedItem, setSelectedItem] = useState(null);
  const [userData, setUserData] = useState({
    userId: 'workershigh91@naver.com'
  });

  const [dialog, setDialog] = useState({
    open: false
  });

  const fetchUserData = async () => {
    try {
      const rs = await userService.getUserData();

      if (!rs.error) {
        setUserData({ ...rs?.data });
      }
    } catch (error) {
      console.error('Error fetching store data:', error);
    }
  };
  const getPolicyList = async () => {
    try {
      const rs = await signUpService.getTermsAndPolicy({ locale: version });
      if (rs?.data) {
        setPolicyList(rs.data?.slice(0, rs.data.length - 1));
      }
    } catch (error) {
      console.error('Error fetching policy list:', error);
    }
  };

  useEffect(() => {
    if (activeNav !== BOTTOM_NAVS.MY_PAGE)
      dispatch(setActiveNav(BOTTOM_NAVS.MY_PAGE));

    fetchUserData();
    getPolicyList();
  }, [location?.search]);

  return (
    <ReactChannelIO
      // 04ad9ae3-07f3-4e83-9799-685e80be8622  a421a2f2-3eb5-4190-b43d-c64163a7b0e9
      pluginKey="a421a2f2-3eb5-4190-b43d-c64163a7b0e9"
      language="ko"
    >
      <Stack
        sx={{
          flexDirection: 'column',
          width: '100%',
          maxWidth: '500px',
          flexGrow: 1,

          position: 'relative'
        }}
      >
        <Stack
          sx={{
            width: '100%',
            maxWidth: '500px',
            top: 0,
            position: 'fixed',
            backgroundColor: '#FFFFFF',
            zIndex: 1002
          }}
        >
          <Stack
            id="navBarHeader"
            sx={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
              backgroundColor: '#FFFFFF',
              width: '100%',
              py: '13px',
              px: 2.5,
              height: { xs: '50px' }
            }}
          >
            <Stack
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                flexGrow: 1
              }}
            >
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: '#202020',
                  letterSpacing: '-0.56px'
                }}
              >
                마이페이지
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        {/* profile */}
        <Stack sx={{ width: '100%', mt: '50px', py: 2.5, px: 2.5, gap: 3 }}>
          <Stack
            sx={{ width: '100%', gap: 0 }}
            onClick={() => navigate('profile')}
          >
            <Stack
              sx={{
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <Typography
                sx={{
                  fontSize: 20,
                  letterSpacing: '-0.8',
                  fontWeight: 700,
                  color: '#202020'
                }}
              >
                {' '}
                안녕하세요
              </Typography>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
              >
                <path d="M1 13L7 7L1 0.999999" stroke="black" />
              </svg>
            </Stack>
            {/* id */}
            <Stack>
              <Typography
                sx={{
                  fontSize: 20,
                  letterSpacing: '-0.8px',
                  fontWeight: 500,
                  color: '#202020'
                }}
              >
                {userData?.email}
              </Typography>
            </Stack>
          </Stack>
          {/* pickup address */}
          <Stack
            sx={{ flexDirection: 'row', alignItems: 'center', gap: 0.5 }}
            onClick={() => navigate('branch-select')}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ marginBottom: '2px' }}
              fill="none"
            >
              <rect width="24" height="24" fill="white" />
              <path
                d="M12 5C9.23571 5 7 7.25064 7 10.0334C7 13.0318 10.1571 17.1664 11.4571 18.7411C11.7429 19.0863 12.2643 19.0863 12.55 18.7411C13.8429 17.1664 17 13.0318 17 10.0334C17 7.25064 14.7643 5 12 5ZM12 11.831C11.0143 11.831 10.2143 11.0257 10.2143 10.0334C10.2143 9.04109 11.0143 8.23575 12 8.23575C12.9857 8.23575 13.7857 9.04109 13.7857 10.0334C13.7857 11.0257 12.9857 11.831 12 11.831Z"
                fill="#1B2872"
              />
            </svg>
            <Typography
              sx={{
                fontSize: 14,
                letterSpacing: '-0.56px',
                fontWeight: 500,
                color: '#1B2872'
              }}
            >
              픽업장소 관리
            </Typography>
          </Stack>
        </Stack>

        {/* divider */}
        <Stack
          sx={{ width: '100%', height: '5px', backgroundColor: '#F2F2F2' }}
        >
          <Stack
            sx={{ width: '100%', height: '1px', backgroundColor: '#E7E7E7' }}
          />
        </Stack>

        {/* customer service */}
        <CustomerServiceLinks userData={userData} />

        {/* information */}
        <Stack sx={{ width: '100%', pt: 2.5, px: 2.5 }}>
          <Stack sx={{ pb: 2.5 }}>
            <Stack sx={{ width: '100%', pb: 2.5 }}>
              <Typography
                sx={{
                  fontSize: 14,
                  letterSpacing: '-0.56px',
                  fontWeight: 700,
                  color: '#202020'
                }}
              >
                정보
              </Typography>
            </Stack>
            {policyList?.length > 0 &&
              policyList?.map((item, index) => (
                <Stack
                  sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '4px',
                    py: 2
                  }}
                  onClick={() => {
                    setDialog({ ...dialog, open: true });
                    setSelectedItem(item);
                  }}
                >
                  {index === 0 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M16.7606 0.123047H1.24696C0.622553 0.123047 0.117188 0.675314 0.117188 1.3571C0.117188 2.03888 0.593359 2.5496 1.18857 2.58381V12.0383C1.18857 12.6541 1.60858 13.1526 2.12293 13.1526H8.85889V15.176C8.24123 15.2542 7.76056 15.8285 7.76056 16.5225C7.76056 17.2702 8.31984 17.8787 9.00489 17.8787C9.68994 17.8787 10.2515 17.2702 10.2515 16.5225C10.2515 15.8285 9.76855 15.2542 9.15088 15.176V13.1526H15.8868C16.4012 13.1526 16.8212 12.6517 16.8212 12.0383V2.58381C17.4187 2.5496 17.8948 2.01444 17.8948 1.3571C17.8948 0.699751 17.3872 0.123047 16.7628 0.123047H16.7606ZM9.00264 17.561C8.47706 17.561 8.05031 17.0943 8.05031 16.5225C8.05031 15.9506 8.47706 15.4839 9.00264 15.4839C9.52822 15.4839 9.95722 15.9506 9.95722 16.5225C9.95722 17.0943 9.52822 17.561 9.00264 17.561ZM16.527 12.0383C16.527 12.4782 16.2395 12.835 15.8846 12.835H2.12293C1.76805 12.835 1.48055 12.4782 1.48055 12.0383V2.5887H16.5292V12.0359L16.527 12.0383ZM16.7606 2.27102H1.24696C0.78427 2.27102 0.409181 1.86049 0.409181 1.3571C0.409181 0.853701 0.78427 0.440723 1.24696 0.440723H16.7606C17.2233 0.440723 17.6028 0.851258 17.6028 1.3571C17.6028 1.86293 17.2255 2.27102 16.7606 2.27102Z"
                        fill="#202020"
                      />
                      <path
                        d="M9 18C8.25206 18 7.64337 17.3378 7.64337 16.5216C7.64337 15.808 8.10831 15.202 8.7417 15.0701V13.274H2.11804C1.5408 13.274 1.07137 12.7193 1.07137 12.0375V2.69291C0.462688 2.60005 0 2.03313 0 1.35623C0 0.608471 0.557025 0 1.24208 0H16.7557C17.443 0 18 0.608471 18 1.35623C18 2.03557 17.5373 2.6025 16.9264 2.69291V12.0375C16.9264 12.7193 16.4569 13.274 15.8797 13.274H9.25605V15.0701C9.88944 15.202 10.3566 15.808 10.3566 16.5216C10.3566 17.3378 9.74794 18 8.99776 18H9ZM1.24432 0.244366C0.6828 0.244366 0.226848 0.742873 0.226848 1.35623C0.226848 1.96959 0.651357 2.429 1.19041 2.46077L1.29598 2.4681V12.0375C1.29598 12.5849 1.66434 13.0296 2.11804 13.0296H8.96631V15.2851L8.86748 15.2973C8.29698 15.3706 7.86798 15.8985 7.86798 16.524C7.86798 17.2058 8.37559 17.7581 9 17.7581C9.6244 17.7581 10.1343 17.2034 10.1343 16.524C10.1343 15.8985 9.70302 15.3706 9.13252 15.2998L9.03369 15.2875V13.032H15.882C16.3357 13.032 16.704 12.5873 16.704 12.0399V2.46565L16.8096 2.46077C17.3531 2.429 17.7776 1.94515 17.7776 1.35623C17.7776 0.767309 17.3194 0.244366 16.7579 0.244366H1.24432ZM9 17.6823C8.41377 17.6823 7.93536 17.1618 7.93536 16.5216C7.93536 15.8813 8.41377 15.3608 9 15.3608C9.58622 15.3608 10.0669 15.8813 10.0669 16.5216C10.0669 17.1618 9.58847 17.6823 9 17.6823ZM9 15.6052C8.53731 15.6052 8.15997 16.0157 8.15997 16.5216C8.15997 17.0274 8.53731 17.438 9 17.438C9.46269 17.438 9.84227 17.0274 9.84227 16.5216C9.84227 16.0157 9.46493 15.6052 9 15.6052ZM15.882 12.9563H2.12029C1.70252 12.9563 1.36336 12.5433 1.36336 12.0375V2.46565H16.6366V12.035C16.6366 12.5409 16.2975 12.9538 15.882 12.9538V12.9563ZM1.58797 2.71002V12.035C1.58797 12.4065 1.82606 12.7095 2.12029 12.7095H15.882C16.1739 12.7095 16.412 12.4065 16.412 12.035V2.71002H1.58797ZM16.7579 2.39234H1.24432C0.720983 2.39234 0.294235 1.92805 0.294235 1.35623C0.294235 0.784415 0.720983 0.317676 1.24432 0.317676H16.7579C17.2835 0.317676 17.7125 0.781971 17.7125 1.35623C17.7125 1.93049 17.2835 2.39234 16.7579 2.39234ZM1.24432 0.562042C0.844517 0.562042 0.518842 0.918816 0.518842 1.35623C0.518842 1.79365 0.844517 2.14798 1.24432 2.14798H16.7579C17.16 2.14798 17.4879 1.7912 17.4879 1.35623C17.4879 0.92126 17.16 0.562042 16.7579 0.562042H1.24432Z"
                        fill="#202020"
                      />
                      <path
                        d="M4.93897 5.04375H13.0585C13.1394 5.04375 13.2045 4.97288 13.2045 4.88491C13.2045 4.79694 13.1394 4.72607 13.0585 4.72607H4.93897C4.85811 4.72607 4.79297 4.79694 4.79297 4.88491C4.79297 4.97288 4.85811 5.04375 4.93897 5.04375Z"
                        fill="#202020"
                      />
                      <path
                        d="M13.0575 5.16507H4.93799C4.79649 5.16507 4.67969 5.038 4.67969 4.88405C4.67969 4.7301 4.79649 4.60303 4.93799 4.60303H13.0575C13.199 4.60303 13.3158 4.7301 13.3158 4.88405C13.3158 5.038 13.199 5.16507 13.0575 5.16507ZM4.93799 4.84739C4.92002 4.84739 4.90429 4.8645 4.90429 4.88405C4.90429 4.9036 4.92002 4.9207 4.93799 4.9207H13.0575C13.0755 4.9207 13.0912 4.9036 13.0912 4.88405C13.0912 4.8645 13.0755 4.84739 13.0575 4.84739H4.93799Z"
                        fill="#202020"
                      />
                      <path
                        d="M4.93897 7.86895H13.0585C13.1394 7.86895 13.2045 7.79808 13.2045 7.71011C13.2045 7.62214 13.1394 7.55127 13.0585 7.55127H4.93897C4.85811 7.55127 4.79297 7.62214 4.79297 7.71011C4.79297 7.79808 4.85811 7.86895 4.93897 7.86895Z"
                        fill="#202020"
                      />
                      <path
                        d="M13.0575 7.99026H4.93799C4.79649 7.99026 4.67969 7.86319 4.67969 7.70924C4.67969 7.55529 4.79649 7.42822 4.93799 7.42822H13.0575C13.199 7.42822 13.3158 7.55529 13.3158 7.70924C13.3158 7.86319 13.199 7.99026 13.0575 7.99026ZM4.93799 7.67259C4.92002 7.67259 4.90429 7.68969 4.90429 7.70924C4.90429 7.72879 4.92002 7.7459 4.93799 7.7459H13.0575C13.0755 7.7459 13.0912 7.72879 13.0912 7.70924C13.0912 7.68969 13.0755 7.67259 13.0575 7.67259H4.93799Z"
                        fill="#202020"
                      />
                      <path
                        d="M4.93897 10.6937H13.0585C13.1394 10.6937 13.2045 10.6228 13.2045 10.5348C13.2045 10.4468 13.1394 10.376 13.0585 10.376H4.93897C4.85811 10.376 4.79297 10.4468 4.79297 10.5348C4.79297 10.6228 4.85811 10.6937 4.93897 10.6937Z"
                        fill="#202020"
                      />
                      <path
                        d="M13.0575 10.815H4.93799C4.79649 10.815 4.67969 10.6879 4.67969 10.534C4.67969 10.38 4.79649 10.2529 4.93799 10.2529H13.0575C13.199 10.2529 13.3158 10.38 13.3158 10.534C13.3158 10.6879 13.199 10.815 13.0575 10.815ZM4.93799 10.4973C4.92002 10.4973 4.90429 10.5144 4.90429 10.534C4.90429 10.5535 4.92002 10.5706 4.93799 10.5706H13.0575C13.0755 10.5706 13.0912 10.5535 13.0912 10.534C13.0912 10.5144 13.0755 10.4973 13.0575 10.4973H4.93799Z"
                        fill="#202020"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M13.8816 4.02574C13.8816 4.02574 13.8793 4.01676 13.8793 4.01227C13.8793 3.9988 13.877 3.98309 13.87 3.96962C13.8631 3.95615 13.8538 3.94269 13.8445 3.93146C13.8445 3.92922 13.8422 3.92473 13.8398 3.92248L9.94464 0.15593C9.93071 0.142462 9.91446 0.133483 9.89821 0.124505C9.87964 0.117771 9.86107 0.113281 9.84018 0.113281H0.269294C0.185726 0.113281 0.118408 0.178377 0.118408 0.259185V17.7429C0.118408 17.8237 0.185726 17.8888 0.269294 17.8888H13.7331C13.8166 17.8888 13.8839 17.8237 13.8839 17.7429V4.02574H13.8816ZM13.5799 17.597H0.417856V0.405088H9.68697V4.03696C9.68697 4.07512 9.70322 4.11328 9.73108 4.14022C9.75893 4.16715 9.79839 4.18287 9.83786 4.18287L13.5799 4.17164V17.5948V17.597ZM9.98874 3.89106V0.611598L13.3686 3.88208L9.98874 3.89106Z"
                        fill="#202020"
                      />
                      <path
                        d="M13.7307 18H0.266953C0.120708 18 0 17.8833 0 17.7419V0.258137C0 0.116723 0.120708 0 0.266953 0H9.83784C9.87266 0 9.90748 0.00673401 9.93998 0.020202C9.96551 0.0314254 9.98872 0.0448934 10.0096 0.0606061L10.0305 0.0695847L10.0398 0.0875421L13.9443 3.87205C13.9443 3.87205 13.9652 3.8945 13.9791 3.92593C13.9907 3.95286 13.993 3.97755 13.9954 3.99776L14 4.01347V4.02469V17.7396C14 17.881 13.8793 17.9978 13.733 17.9978L13.7307 18ZM0.266953 0.224467C0.248382 0.224467 0.232134 0.24018 0.232134 0.258137V17.7419C0.232134 17.7598 0.248382 17.7755 0.266953 17.7755H13.7307C13.7493 17.7755 13.7655 17.7598 13.7655 17.7419V4.0202L13.7447 3.98878L9.83784 0.222222H0.266953V0.224467ZM13.6959 17.7082H0.301771V0.291807H9.80302V4.03591C9.80302 4.03591 9.80766 4.05387 9.8123 4.06061C9.81694 4.06734 9.82855 4.06958 9.83784 4.06958L13.6959 4.05836V17.7059V17.7082ZM0.533905 17.4837H13.4638V4.28507L9.83784 4.2963C9.76588 4.2963 9.69856 4.26936 9.64749 4.21998C9.59642 4.17059 9.56856 4.1055 9.56856 4.03816V0.516274H0.531589V17.4815L0.533905 17.4837ZM9.87266 4.00224V0.338945L13.6472 3.99102L9.87266 4.00224ZM10.1048 0.882155V3.77778L13.09 3.7688L10.1048 0.882155Z"
                        fill="#202020"
                      />
                      <path
                        d="M2.66895 8.44473C2.66895 8.52554 2.73627 8.59063 2.81984 8.59063H10.5824C10.666 8.59063 10.7333 8.52554 10.7333 8.44473C10.7333 8.36392 10.666 8.29883 10.5824 8.29883H2.81984C2.73627 8.29883 2.66895 8.36392 2.66895 8.44473Z"
                        fill="#202020"
                      />
                      <path
                        d="M10.583 8.70182H2.82043C2.67418 8.70182 2.55347 8.5851 2.55347 8.44368C2.55347 8.30227 2.67418 8.18555 2.82043 8.18555H10.583C10.7292 8.18555 10.8499 8.30227 10.8499 8.44368C10.8499 8.5851 10.7292 8.70182 10.583 8.70182ZM2.82043 8.41001C2.80186 8.41001 2.7856 8.42573 2.7856 8.44368C2.7856 8.46164 2.80186 8.47735 2.82043 8.47735H10.583C10.6016 8.47735 10.6178 8.46164 10.6178 8.44368C10.6178 8.42573 10.6016 8.41001 10.583 8.41001H2.82043Z"
                        fill="#202020"
                      />
                      <path
                        d="M10.5824 11.5488H2.81984C2.73627 11.5488 2.66895 11.6139 2.66895 11.6947C2.66895 11.7755 2.73627 11.8406 2.81984 11.8406H10.5824C10.666 11.8406 10.7333 11.7755 10.7333 11.6947C10.7333 11.6139 10.666 11.5488 10.5824 11.5488Z"
                        fill="#202020"
                      />
                      <path
                        d="M10.583 11.9518H2.82043C2.67418 11.9518 2.55347 11.8351 2.55347 11.6937C2.55347 11.5523 2.67418 11.4355 2.82043 11.4355H10.583C10.7292 11.4355 10.8499 11.5523 10.8499 11.6937C10.8499 11.8351 10.7292 11.9518 10.583 11.9518ZM2.82043 11.66C2.80186 11.66 2.7856 11.6757 2.7856 11.6937C2.7856 11.7116 2.80186 11.7274 2.82043 11.7274H10.583C10.6016 11.7274 10.6178 11.7116 10.6178 11.6937C10.6178 11.6757 10.6016 11.66 10.583 11.66H2.82043Z"
                        fill="#202020"
                      />
                      <path
                        d="M10.5824 14.7969H2.81984C2.73627 14.7969 2.66895 14.862 2.66895 14.9428C2.66895 15.0236 2.73627 15.0887 2.81984 15.0887H10.5824C10.666 15.0887 10.7333 15.0236 10.7333 14.9428C10.7333 14.862 10.666 14.7969 10.5824 14.7969Z"
                        fill="#202020"
                      />
                      <path
                        d="M10.583 15.1999H2.82043C2.67418 15.1999 2.55347 15.0831 2.55347 14.9417C2.55347 14.8003 2.67418 14.6836 2.82043 14.6836H10.583C10.7292 14.6836 10.8499 14.8003 10.8499 14.9417C10.8499 15.0831 10.7292 15.1999 10.583 15.1999ZM2.82043 14.9081C2.80186 14.9081 2.7856 14.9238 2.7856 14.9417C2.7856 14.9597 2.80186 14.9754 2.82043 14.9754H10.583C10.6016 14.9754 10.6178 14.9597 10.6178 14.9417C10.6178 14.9238 10.6016 14.9081 10.583 14.9081H2.82043Z"
                        fill="#202020"
                      />
                    </svg>
                  )}
                  <Typography
                    sx={{
                      fontSize: 14,
                      letterSpacing: '-0.56px',
                      fontWeight: 500,
                      color: '#202020'
                    }}
                  >
                    {item?.title}
                  </Typography>
                </Stack>
              ))}
          </Stack>
        </Stack>
        {selectedItem && (
          <MyModal
            open={dialog?.open}
            setOpen={() => setDialog({ ...dialog, open: false, title: '' })}
            title={selectedItem?.title}
            titleStyle={{ height: '50px' }}
            hasBackButton
            hideDialogButton
          >
            <Stack
              dangerouslySetInnerHTML={{ __html: selectedItem?.content }}
              sx={{
                'figure table': {
                  border: '1px solid #EFEFEF',
                  borderCollapse: 'collapse',
                  width: '100%',
                  th: {
                    span: {
                      fontSize: '12px !important',
                      whiteSpace: 'pre-line',
                      wordBreak: 'keep-all', // Prevent breaking words
                      overflowWrap: 'break-word' // Handle long words
                    },
                    backgroundColor: '#EFEFEF !important',
                    whiteSpace: 'pre-line',
                    wordBreak: 'keep-all', // Prevent breaking words
                    overflowWrap: 'break-word', // Handle long words
                    minWidth: '40px',
                    maxWidth: '40px',
                    color: '#202020'
                  },
                  'th, td': {
                    border: '1px solid #EFEFEF',
                    span: {
                      fontSize: '10px !important',
                      whiteSpace: 'pre-line',
                      wordBreak: 'keep-all', // Prevent breaking words
                      overflowWrap: 'break-word' // Handle long words
                    },
                    whiteSpace: 'pre-line',
                    wordBreak: 'keep-all', // Prevent breaking words
                    overflowWrap: 'break-word', // Handle long words
                    padding: '4px',
                    textAlign: 'left'
                  }
                },
                figure: {
                  width: '100% !important',
                  margin: 0
                }
              }}
            />
          </MyModal>
        )}
      </Stack>
    </ReactChannelIO>
  );
};

export default MyPage;
